import { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

export default css`
  .blueprint-swiper__bullet {
    margin: 0 5px;
    background-color: ${themeGet('colors.calculator.dot')};
    border-radius: 5px;
    height: 10px;
    width: 20px;
    cursor: pointer;
  }

  .blueprint-swiper__bullet--active {
    width: 40px;
    background-color: ${themeGet('colors.calculator.action')};
  }

  .blueprint-swiper__bullet-pink {
    margin: 0 5px;
    background-color: ${themeGet('colors.pinkAmaranthLight')};
    border-radius: 5px;
    height: 10px;
    width: 20px;
    cursor: pointer;
  }

  .blueprint-swiper__bullet-pink--active {
    width: 40px;
    background-color: ${themeGet('colors.pinkAmaranth')};
  }
`
